(function ($) {
  Drupal.behaviors.desire_hero = {
    attach: function (context) {
      $('#desire_mod1', context).once(function () {
        var thisModuleName = 'desire_mod1';
        var triggerMod = '#desire_mod1';
        var $thismodule = $('#desire_mod1');
        // Init scrollMagic Controller Class
        var controller = new ScrollMagic.Controller();
        var textureAnimateFromSideScene;
        var fadeThisModuleScene;
        var offset, offsetTexture, delayTexture;
        var moduleWillFade = false;
        var hasFaded = false;
        var urlHash = window.location.href.split('#')[1];

        // If module is called in URL, scroll to module.
        if (urlHash === thisModuleName) {
          $('html,body').animate(
            {
              scrollTop: $thismodule.offset().top - 85
            },
            1500
          );
        }

        // Check if Content Author has specified for module to fade in.
        if ($thismodule.data('scrollmagic') === 1) {
          moduleWillFade = true;
        }

        // Hide and push down the module if it is to be faded in.
        if (moduleWillFade) {
          $thismodule.addClass('hideModules');
        }

        // Add class to parent div to have a full black BG
        $thismodule.parent().parent().addClass('desire__module-dark-bg');

        // Init scrollMagic Scene Class to animate first texture
        if ($('body').hasClass('device-mobile')) {
          offsetTexture = 200;
          delayTexture = 2000;
        } else {
          offsetTexture = 500;
          delayTexture = 0;
        }

        textureAnimateFromSideScene = new ScrollMagic.Scene({
          triggerElement: triggerMod,
          offset: offsetTexture
        }).on('start', function () {
          slideThisTexture();
        });
        controller.addScene([textureAnimateFromSideScene]);

        // Handle texture slide-in from side.
        function slideThisTexture() {
          $('.js-desire_mod1__texture').delay(delayTexture).animate(
            {
              marginLeft: '0%'
            },
            800,
            'easeOutQuad'
          );
        }

        // Handle module fade-in from CMS.
        function fadeThisModule() {
          if (hasFaded === false) {
            hasFaded = true;
            $thismodule.animate(
              {
                opacity: 1,
                paddingTop: '0'
              },
              350,
              'easeOutQuad'
            );
          } else {
            return;
          }
        }

        $(window).on('load', function () {
          // Handle the hero text fade-in.
          // To only play once spinner is gone and
          // page is loaded as its always the top of the page.
          $('.js-desire__hero-block_1, .js-boutique_vid_play_img').animate(
            {
              opacity: '0'
            },
            0
          );
          // check if on mobile
          if ($('body').hasClass('device-mobile')) {
            $('.js-desire__hero-block_1').delay(250).animate(
              {
                opacity: 1,
                top: '18.2%'
              },
              500
            );
            $('.js-boutique_vid_play_img').animate(
              {
                opacity: 1,
                top: '29.5%'
              },
              500
            );
          } else {
            $('.js-desire__hero-block_1').delay(250).animate(
              {
                opacity: 1,
                top: '28.5%'
              },
              500
            );
            $('.js-boutique_vid_play_img').animate(
              {
                opacity: 1,
                top: '35.5%'
              },
              500
            );
          }
          // Content-Author-managed - Module Fade.
          if (moduleWillFade) {
            // Put in window load so that the page height is ready
            // by the time we get to animating.

            // Set the offset.
            if ($thismodule.data('offset')) {
              offset = $thismodule.data('offset');
            } else {
              offset = 0;
            }

            // Init scrollMagic Scene Class
            fadeThisModuleScene = new ScrollMagic.Scene({
              triggerElement: triggerMod,
              offset: offset
            }).on('start', function () {
              fadeThisModule();
            });
            controller.addScene([fadeThisModuleScene]);
          }
        });
      });
    }
  };
})(jQuery);
